module.exports = __webpack_public_path__ + "img/semaforo-inactive.e67fe393.svg";